import { MK_TWENTY_FOUR_WEEKS_8999_TWENTY_FOUR_WEEKS_4999_INTRO_PLAN, MK_TWELVE_WEEKS_5999_TWELVE_WEEKS_3499_INTRO_PLAN, MK_FOUR_WEEKS_2999_FOUR_WEEKS_1999_INTRO_PLAN, MK_TWENTY_FOUR_WEEKS_8999_WITHOUT_TRIAL_PLAN, MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN, MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN, MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN } from '../shared/subscription-plans';

const subscriptionMapping = {
    [MK_FOUR_WEEKS_2999_FOUR_WEEKS_1999_INTRO_PLAN]: {
        name: '4-Week plan',
        membershipName: '4-week membership'
    },
    [MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN]: {
        name: '4-Week plan',
        membershipName: '4-week membership'
    },
    [MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN]: {
        name: '1-Week Trial',
        membershipName: '1-week membership',
        isPopular: true,
        isDiscountBadgeHidden: true
    },
    [MK_TWELVE_WEEKS_5999_TWELVE_WEEKS_3499_INTRO_PLAN]: {
        name: '12-Week plan',
        membershipName: '12-week membership'
    },
    [MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN]: {
        name: '12-Week plan',
        membershipName: '12-week membership'
    },
    [MK_TWENTY_FOUR_WEEKS_8999_TWENTY_FOUR_WEEKS_4999_INTRO_PLAN]: {
        name: '24-Week plan',
        membershipName: '24-week membership',
        isPopular: true
    },
    [MK_TWENTY_FOUR_WEEKS_8999_WITHOUT_TRIAL_PLAN]: {
        name: '24-Week plan',
        membershipName: '24-week membership',
        isPopular: true
    }
};

const DAYS_IN_MONTH = 30;
const DAYS_IN_WEEK = 7;

const getPricePerDay = ({ price, billingPeriod }) => {
    if (billingPeriod.unit && billingPeriod.unit === 'week') {
        return Math.round(price / (DAYS_IN_WEEK * Number(billingPeriod.value)));
    }

    return Math.round(price / DAYS_IN_MONTH);
};

const toFixedNumber = value => {
    return Number.parseFloat(value || 0).toFixed(2) || '';
};

const getDiscountPrice = ({ trial, price }, displayOldPrice) => {
    if (!trial && displayOldPrice) {
        return `$${toFixedNumber((Number.parseFloat(displayOldPrice.slice(1)) * 100 - price) / 100)}`;
    }

    return trial ? `$${toFixedNumber((price - trial.price) / 100)}` : 0;
};

const getBillingPeriod = ({ billingPeriod }) => {
    return billingPeriod;
};

const getSummaryPriceValue = ({ price }) => {
    return price;
};

const getSummaryPrice = subscriptionData => {
    return `$${toFixedNumber(getSummaryPriceValue(subscriptionData) / 100)}`;
};

const getSummaryPricePerDay = subscriptionData => {
    return getPricePerDay({
        plan: subscriptionData.plan,
        price: getSummaryPriceValue(subscriptionData),
        billingPeriod: getBillingPeriod(subscriptionData),
        hasTrial: Boolean(subscriptionData.trial)
    });
};

const subscriptionPlanMapper = {
    getPlanName(planId) {
        return subscriptionMapping[planId]?.name ?? '';
    },

    toDomain(subscriptionData) {
        const data = subscriptionMapping[subscriptionData.plan];

        if (!data) {
            return null;
        }

        return {
            ...data,
            price: `$${toFixedNumber(subscriptionData.price / 100)}`,
            doubledPrice: `$${Math.round(subscriptionData.price / 100 * 2).toFixed(2)}`,
            discountPrice: getDiscountPrice(subscriptionData, data.displayOldPrice),
            pricePerDay: getPricePerDay(subscriptionData),
            billingPeriod: subscriptionData.billingPeriod,
            summaryBillingPeriod: getBillingPeriod(subscriptionData),
            summaryPrice: getSummaryPrice(subscriptionData),
            summaryPricePerDay: getSummaryPricePerDay(subscriptionData),
            plan: subscriptionData.plan,
            trialDuration: subscriptionData.trial ? subscriptionData.trial.billingPeriod.value : null,
            trial: subscriptionData.trial
                ? {
                    ...subscriptionData.trial,
                    price: `$${toFixedNumber(subscriptionData.trial.price / 100)}`,
                    pricePerDay: getPricePerDay({ plan: subscriptionData.plan, price: subscriptionData.trial.price, billingPeriod: subscriptionData.trial.billingPeriod, hasTrial: true })
                }
                : null
        };
    }
};

export {
    subscriptionPlanMapper
};
